import { enrollmentEngagementService } from '@/data/services/enrollment/enrollment-engagement-service'
import { EnrollmentEngagementData } from '@/data/services/enrollment/enrollment-engagement-service-types'

export async function loadUserEnrollmentEngagement(
  enrollmentId: string
): Promise<EnrollmentEngagementData> {
  return enrollmentEngagementService.fetchEnrollmentEngagement(enrollmentId)
}
